/**
 * Labstep
 *
 * @module components/ResourceItem/EmptyState
 * @desc Empty state for resource item
 */

import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import type React from 'react';
import type { IResourceItemEmptyStateProps } from './types';

export const ResourceItemEmptyState: React.FC<
  IResourceItemEmptyStateProps
> = (props) => (
  <CardEmptyState
    title={`No ${ResourceItem.getHumanReadableEntityName(true)}`}
    explanation="Items are used to track the different batches, containers or aliquots of your resources. Track the location, availability and amount remaining of each item. Reference which item was used in each experiment."
    src="/img/empty-state/inventory.svg"
    {...props}
  />
);
